import { Tab, Tabs } from "@nulogy/components";
import PageWithBreadcrumbs from "components/pages/PageWithBreadcrumbs";
import React, { useState } from "react";
import Exports from "./Exports";
import Imports from "./Imports";

export default function ManageData() {
  const [tab, setTab] = useState(0);
  const onTabClick = (_event, index) => {
    setTab(index);
  };

  return (
    <PageWithBreadcrumbs title="Manage data">
      <Tabs onTabClick={onTabClick} selectedIndex={tab}>
        <Tab label="Imports">
          <Imports />
        </Tab>
        <Tab label="Exports">
          <Exports />
        </Tab>
      </Tabs>
    </PageWithBreadcrumbs>
  );
}
